<template>
    <div>
        <div class="fixed pin z-50 overflow-auto py-8" v-on:click.self="$emit('close')"
             style="background-color: rgba(0, 0, 0, 0.5)">
            <div class="rounded m-auto flex-col flex"
                 :class="{'lg:w-1/2': !large, 'mx-8': large}">
                <div class="">
                    <div class="rounded-t-lg" :class="{'bg-grey-light text-grey-darker p-4': !large, 'px-4 pt-4 border-b bg-white text-black': large}">


                        <slot name="header"></slot>

                        <!--<div class="flex justify-between">

                            <div class="">
                                <slot name="header"></slot>
                            </div>

                            <div class="">
                                <a class="hover:text-red cursor-pointer p-2" accesskey="x" v-on:click="$emit('close')">
                                    <i class="fa fa-times"></i>
                                </a>
                            </div>
                        </div>-->
                    </div>
                    <div class="rounded-b-lg bg-grey-lightest" :class="{'lg:p-8': !large}">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            large: {
                type: Boolean,
                default: false,
            },
        },

        created() {
            document.body.className = "fixed overflow-none";
        },

        destroyed() {
            document.body.className = "";
        }
    }
</script>
